import { DatabaseZap, SearchX } from "lucide-react";
import { Link } from "react-router-dom";

export default function EmptyState({ icon = "database", title, body, actionLabel, actionTo, testid }) {
  const Icon = icon === "search" ? SearchX : DatabaseZap;
  return (
    <div
      data-testid={testid}
      className="flex flex-col items-center gap-4 rounded-xl border border-dashed border-[#1E2638] bg-[#0D111A]/70 px-6 py-16 text-center"
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-full border border-[#00FF87]/30 bg-[#0D111A] shadow-[0_0_18px_rgba(0,255,135,0.15)]">
        <Icon className="h-6 w-6 text-[#00FF87]" />
      </span>
      <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-slate-100">{title}</h3>
      <p className="max-w-md text-sm leading-relaxed text-slate-400">{body}</p>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          data-testid={`${testid}-action`}
          className="mt-2 rounded-md bg-[#00FF87] px-4 py-2 font-mono2 text-xs font-bold uppercase tracking-wider text-[#07090E] transition-all hover:shadow-[0_0_18px_rgba(0,255,135,0.5)]"
        >
          {actionLabel}
        </Link>
      )}
    </div>
  );
}
